import { BaseViewModel } from "./baseviewmodel";
import { ResponseContainer } from "../Models/responsecontainer";
//import { ToastNotification, ToastNotificationKind } from "./toastnotification";

class DialogViewModel extends BaseViewModel {
    constructor(public id: string, public title: string, public content: string, public actions: DialogAction[]) {
        super(null);
        $.each(this.actions,
            (index: number, action: DialogAction) => {
                action.parent = this;
            });

        this.actions = this.actions.sort((b) => b.ordinal);
    }
    public isBusy = ko.observable<boolean>(false);
    public onBeforeShowModal: (dialogElement: HTMLElement) => void;
    public close() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            dialogElement.close();
        }
        $(`#dialog-${this.id}`).remove();
    }

    public hide() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement != null) {
            $(dialogElement).hide();
        }
    }

    public show() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);

        if (dialogElement != null) {
            super.upgradeMDL();
            $(dialogElement).show();
        }
    }

    //public showNotification(notification: ToastNotification): void {
    //    notification.show();
    //}

    /**
     * Fetch json data
     */
    // tslint:disable-next-line
    protected getJsonData<T>(url: string, success: (data: T) => void, error?: JQuery.Ajax.ErrorCallback<any>, complete?: JQuery.Ajax.CompleteCallback<any>) {
        var call = $.getJSON(url, (response: ResponseContainer) => {
            if (success != null) {
                success(response.value as T);
            }
        });
        if (error) {
            call.fail(error);
        }
        if (complete) {
            call.always(complete);
        }
    }

    public setNarrowView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-narrowwide");
        }
    }

    public setWideView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-extrawide");
        }
    }

    public setAltraWideView() {
        // tslint:disable-next-line
        var dialogElement = ($(`#dialog-${this.id}`).get(0) as any);
        if (dialogElement !== null) {
            $(dialogElement).addClass("mdl-dialog-altrawide");
        }
    }

    public refreshButtons() {
        $.each(this.actions,
            (index: number, action: DialogAction) => {
                if (action.isHidden) {
                    this.hideButton(action.caption);
                } else {
                    this.showButton(action.caption);
                }
            });
    }

    public hideButton(name: string) {
        var actions = $(".mdl-button").get();
        for (let action of actions) {
            if ($(action).text().toUpperCase() == name.toUpperCase()) {
                $(action).hide();
            }
        }
    }

    public showButton(name: string) {
        var actions = $(".mdl-button").get();
        for (let action of actions) {
            if ($(action).text().toUpperCase() == name.toUpperCase()) {
                $(action).show();
            }
        }
    }
}

class DialogAction {
    constructor(public caption: string, public actionHandler: () => boolean, public isClose: boolean = false, public ordinal: number = 0, public isHidden: boolean = false) { }
    public parent: DialogViewModel;
    public action(): void {
        if (!this.actionHandler()) {
            if (this.isClose) {
                this.parent.close();
            }
        }
    }
}

export { DialogAction, DialogViewModel };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/dialogviewmodel.ts